import React from 'react'
import {NavLink} from 'react-router-dom'
import { useSelector } from 'react-redux'

const CartBtn = () => {
  // get a state of addItems
  const state = useSelector((state)=> state.addItems)
  return (
    <>
        <NavLink to="/cart" className='btn btn-outline-primary ml-2'>
          <span className='fa fa-shopping-cart mr-1'></span> Cart ({state.length})
        </NavLink>  
    </>
  )
}

export default CartBtn